import { useState } from "react";
import T from "../theme/colors";

const SIZES = {
  xs: { padding: "3px 10px",  fontSize: 13, gap: 4 },
  sm: { padding: "5px 13px",  fontSize: 14, gap: 5 },
  md: { padding: "8px 16px",  fontSize: 15, gap: 6 },
  lg: { padding: "11px 22px", fontSize: 16, gap: 7, fontWeight: 600 },
};

export default function Btn({
  children, variant = "primary", size = "md",
  onClick, style = {}, icon, disabled = false, type = "button", loading = false,
}) {
  const [hovered, setHovered] = useState(false);
  const VARIANTS = {
    primary: {
      base:  { background: "var(--grad)", color: "#fff", border: "none", boxShadow: `0 1px 3px rgba(201,82,16,0.3)` },
      hover: { boxShadow: `0 4px 12px rgba(201,82,16,0.35)`, filter: "brightness(1.05)" },
    },
    secondary: {
      base:  { background: "var(--bg-card)", color: "var(--text-0)", border: `1px solid var(--border)`, boxShadow: "var(--shadow-sm)" },
      hover: { borderColor: "var(--border-hover)", background: "var(--bg-hover)" },
    },
    ghost: {
      base:  { background: "transparent", color: "var(--text-1)", border: "none" },
      hover: { background: "var(--bg-hover)", color: "var(--text-0)" },
    },
    danger: {
      base:  { background: "var(--danger-bg)", color: "var(--danger)", border: `1px solid var(--danger-bdr)` },
      hover: { background: "var(--danger-bg)", filter: "brightness(0.97)" },
    },
    success: {
      base:  { background: "var(--success-bg)", color: "var(--success)", border: `1px solid var(--success-bdr)` },
      hover: { background: "var(--success-bg)", filter: "brightness(0.97)" },
    },
    outline: {
      base:  { background: "transparent", color: "var(--primary)", border: `1px solid var(--primary)` },
      hover: { background: "var(--primary-light)" },
    },
  };
  const v = VARIANTS[variant] || VARIANTS.secondary;
  const s = SIZES[size];

  return (
    <button
      type={type}
      onClick={disabled || loading ? undefined : onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        gap: s.gap, border: "none", fontFamily: "var(--font-ui)", fontWeight: 500,
        letterSpacing: "0.01em",
        cursor: disabled || loading ? "not-allowed" : "pointer",
        transition: "all 0.17s ease", borderRadius: 7, whiteSpace: "nowrap",
        opacity: disabled ? 0.55 : 1,
        ...s, ...v.base,
        ...(hovered && !disabled && !loading ? v.hover : {}),
        ...style,
      }}
    >
      {loading
        ? <span style={{ width: 13, height: 13, border: "2px solid currentColor", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite", display: "inline-block" }} />
        : icon && <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      }
      {children}
    </button>
  );
}